import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { LogIn, Shield, Zap, Award } from 'lucide-react';
import { Button } from '../../components/ui/button';

const LoginEN = () => {
  const { login } = useAuth();

  const handleLogin = () => {
    const redirectUrl = `${window.location.origin}/auth/callback`;
    login(redirectUrl);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6 py-20">
      <div className="max-w-5xl w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-center md:text-left">
            <img 
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/3s7e8l1h_logodas.png" 
              alt="Cloud Cheats" 
              className="h-32 w-auto mx-auto md:mx-0 mb-8 drop-shadow-2xl"
            />
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 gaming-title">
              WELCOME TO <span className="text-red-600 glow-red">CLOUD CHEATS</span>
            </h1>
            <p className="text-xl text-gray-400 mb-8">
              Log in to complete your purchase and dominate Free Fire
            </p>

            <div className="space-y-4">
              {[
                { icon: Shield, text: '100% Secure Payment' },
                { icon: Zap, text: 'Instant Delivery After Payment' },
                { icon: Award, text: 'Premium 24/7 Support' }
              ].map((feature, idx) => (
                <div key={idx} className="flex items-center gap-3 text-gray-300">
                  <div className="w-10 h-10 bg-red-600/20 rounded-lg flex items-center justify-center">
                    <feature.icon className="w-5 h-5 text-red-600" />
                  </div>
                  <span className="font-medium">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gray-900 rounded-2xl p-10 border-2 border-red-900/30 shadow-2xl">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-white mb-3 gaming-title">
                SIGN IN OR CREATE ACCOUNT
              </h2>
              <p className="text-gray-400">
                Use your Google account to sign in or create a new account
              </p>
            </div>

            <Button
              onClick={handleLogin}
              className="w-full bg-white hover:bg-gray-100 text-gray-900 font-bold py-6 text-lg rounded-xl shadow-lg transition-all border-2 border-gray-200 hover:border-gray-300 group"
            >
              <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>
              <span className="group-hover:text-red-600 transition-colors">
                Sign In / Create Account
              </span>
            </Button>

            <div className="mt-8 pt-6 border-t border-red-900/20">
              <p className="text-center text-xs text-gray-500">
                Your data is protected. We use Google's secure authentication.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            By logging in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginEN;
